function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface69248786"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.59375 2.9375 C 35.664062 4.519531 39.785156 6.429688 46.21875 7.84375 L 47 8.03125 L 47 8.8125 C 47 38.46875 25.46875 49.59375 25.46875 49.59375 L 25.03125 49.8125 L 24.59375 49.59375 C 24.59375 49.59375 19.128906 47.066406 13.75 40.71875 C 8.371094 34.371094 3 24.132812 3 8.8125 L 3 8.03125 L 3.78125 7.84375 C 10.214844 6.429688 14.335938 4.519531 17.40625 2.9375 C 20.476562 1.355469 22.546875 0 25 0 C 27.453125 0 29.523438 1.355469 32.59375 2.9375 Z M 18.3125 4.71875 C 15.332031 6.25 11.140625 8.128906 5.0625 9.5625 C 5.246094 23.960938 10.222656 33.503906 15.25 39.4375 C 20.019531 45.066406 24.347656 47.230469 24.96875 47.53125 C 26.253906 46.851562 44.570312 36.679688 44.9375 9.5625 C 38.859375 8.128906 34.667969 6.25 31.6875 4.71875 C 28.550781 3.105469 26.644531 2 25 2 C 23.355469 2 21.449219 3.105469 18.3125 4.71875 Z M 18.3125 4.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22 30.8125 L 14.597656 23.410156 L 15.945312 22.0625 L 22 28.121094 L 33.828125 16.292969 L 35.175781 17.640625 Z M 22 30.8125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield1);
export default __webpack_public_path__ + "static/media/shield1.140162ee647f94e12c6f122a385fcf40.svg";
export { ForwardRef as ReactComponent };